import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Backdrop = styled(Box)(() => ({
  zIndex: 1,
  background: "rgba(0,0,0,0.3)",
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));
